<template>
  <div class="page">
    <div class="top">
      <i class="iconfont icon-back" @click="goback()"></i>
      <img src="/static/logo-64x64.png">
    </div>

    <div class="page__bd">
      <article class="weui-article">
        <div
          style="font-size: 18px; font-weight: bold; text-align: center; margin-bottom: 20px;"
        >{{active.title}}</div>
        <p v-html="active.content"></p>
      </article>
    </div>
    <div class="weui-msg__extra-area">
      <div class="weui-footer">
        <p class="weui-footer__links">
          <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
        </p>
        <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import weui from "weui.js";
import axios from "axios";

export default {
  data() {
    return {
      year: moment().format("YYYY"),
      token: "",
      active: {}
    };
  },
  created() {
    let encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    axios
      .get("/api/active/" + this.$route.params.id)
      .then(res => {
        if (res.data.success) {
          this.active = res.data.data;
        } else {
          console.log(err);
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    goback() {
      this.$router.back(-1);
    }
  }
};
</script>

<style scoped>
.weui-msg__extra-area {
  position: relative;
}
.top {
  margin-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #fea100;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.top i {
  position: absolute;
  left: 10px;
  font-size: 22px;
  color: #fea100;
}
.top img {
  height: 26px;
}
.weui-footer {
  margin-bottom: 20px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>




// WEBPACK FOOTER //
// src/components/actives/detail.vue